var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSingleChoiceGrid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_411_3927",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.477295H0V16.4773H16V0.477295Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_411_3927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.47729C6.5 5.30572 7.1716 5.97729 8 5.97729C8.8284 5.97729 9.5 5.30572 9.5 4.47729C9.5 3.64886 8.8284 2.97729 8 2.97729C7.1716 2.97729 6.5 3.64886 6.5 4.47729Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.47729C2.5 5.30572 3.17157 5.97729 4 5.97729C4.82843 5.97729 5.5 5.30572 5.5 4.47729C5.5 3.64886 4.82843 2.97729 4 2.97729C3.17157 2.97729 2.5 3.64886 2.5 4.47729Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.47729C10.5 5.30572 11.1716 5.97729 12 5.97729C12.8284 5.97729 13.5 5.30572 13.5 4.47729C13.5 3.64886 12.8284 2.97729 12 2.97729C11.1716 2.97729 10.5 3.64886 10.5 4.47729Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.47729C6.5 9.30569 7.1716 9.97729 8 9.97729C8.8284 9.97729 9.5 9.30569 9.5 8.47729C9.5 7.64889 8.8284 6.97729 8 6.97729C7.1716 6.97729 6.5 7.64889 6.5 8.47729Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.47729C2.5 9.30569 3.17157 9.97729 4 9.97729C4.82843 9.97729 5.5 9.30569 5.5 8.47729C5.5 7.64889 4.82843 6.97729 4 6.97729C3.17157 6.97729 2.5 7.64889 2.5 8.47729Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.47729C10.5 9.30569 11.1716 9.97729 12 9.97729C12.8284 9.97729 13.5 9.30569 13.5 8.47729C13.5 7.64889 12.8284 6.97729 12 6.97729C11.1716 6.97729 10.5 7.64889 10.5 8.47729Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.4773C6.5 13.3057 7.1716 13.9773 8 13.9773C8.8284 13.9773 9.5 13.3057 9.5 12.4773C9.5 11.6489 8.8284 10.9773 8 10.9773C7.1716 10.9773 6.5 11.6489 6.5 12.4773Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.4773C2.5 13.3057 3.17157 13.9773 4 13.9773C4.82843 13.9773 5.5 13.3057 5.5 12.4773C5.5 11.6489 4.82843 10.9773 4 10.9773C3.17157 10.9773 2.5 11.6489 2.5 12.4773Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.4773C10.5 13.3057 11.1716 13.9773 12 13.9773C12.8284 13.9773 13.5 13.3057 13.5 12.4773C13.5 11.6489 12.8284 10.9773 12 10.9773C11.1716 10.9773 10.5 11.6489 10.5 12.4773Z",
    fill: "#161616"
  }))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSingleChoiceGrid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/single-choice-grid.5fb7baa1c8fbc963106f441c5232ea02.svg";